export default __webpack_public_path__ + "static/media/aboutt.81be5617.png";